import React from 'react';
import Pagination from '../../components/Pagination';

interface ListPagerProps {
  offset: number;
  limit: number;
  total: number;
  page: number;
  pageCount: number;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  noun: string;
}

/**
 * Admin-next's pagination footer — a thin wrapper over the shared Pagination
 * so its offset/onPrev/onNext call sites stay unchanged while the rendering
 * is the one shared implementation.
 */
const ListPager: React.FC<ListPagerProps> = ({
  limit,
  total,
  page,
  pageCount,
  onPrev,
  onNext,
  noun,
}) => {
  if (total === 0) return null;
  return (
    <Pagination
      page={page}
      pageCount={pageCount}
      total={total}
      pageSize={limit}
      noun={noun}
      onPageChange={(next) => (next > page ? onNext() : onPrev())}
    />
  );
};

export default ListPager;
